import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { UntypedFormGroup, ControlValueAccessor, NgControl, UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';

@Component({
  selector: 'intelli-yesorno',
  templateUrl: './intelli-yesorno.component.html',
  styleUrls: ['./intelli-yesorno.component.css'],
  providers: [
    
   { provide: MatFormFieldControl, useExisting: IntelliYesornoComponent },

 ],
 host: {
   '[class.floating]': 'shouldLabelFloat',
   '[id]': 'id',
   '[attr.aria-describedby]': 'describedBy',
 }
})
export class IntelliYesornoComponent  implements MatFormFieldControl<boolean>,ControlValueAccessor { 

  
  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'intelli-yesorno';
  id = `intelli-yesorno-${IntelliYesornoComponent.nextId++}`;
  describedBy = '';


  private onChange: (value: boolean) => void;

  public changeDate()
  {

    console.log(this.value);
    this.onChange(this.value);
  }

  public changeSelect(event:Event)
  {
    console.log(event);
  }

  writeValue(obj: boolean): void {

    this.value = obj;
  }
   registerOnChange(onChange: (value: boolean) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if(isDisabled)
    {
      this.parts.get("textDate").disable();
    }
    else
    {
      this.parts.get("textDate").enable();
    }
  }


  get empty() {
    const { value: { textDate } } = this.parts;

    // console.log("empty:" + dateText + !dateText);
    return !textDate;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): boolean | null {

  const { value: { textDate } } = this.parts

  let strDate:string = textDate;

      if(textDate == "sim")
        return true;
      return false;
  
  }

  set value(value: boolean | null) {

    const  date  = value || false;
    // const { textDate } = tel || new Date();
    
    this.parts.setValue({ textDate:date?"sim":"nao" });
    
  
    this.stateChanges.next();
  }

  constructor(@Optional() @Self() public ngControl: NgControl,fb: UntypedFormBuilder, private fm: FocusMonitor, private elRef: ElementRef<HTMLElement>) {
    
    // Setting the value accessor directly (instead of using
  // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }
    
    this.parts = fb.group({
      textDate: 'nao'
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'select') {
      this.elRef.nativeElement.querySelector('select')!.focus();
    }
  }
}
